<template lang='pug'>
.v-search-small.search-small(:class="{'search-small--focused': focused}")
	.search-small__wrap
		form.search-small__form(@submit.prevent="relocate" @reset.prevent="close")
			img.search-small__icon(:src="icon" alt="" loading="lazy")
			v-field(:field="field" v-model="localQuery" class="search-small__field" @focus="focused = true" @blur="focused = false")
			//-button.search-small__close-btn(aria-label="Очистить" type="reset")
			//-	v-svg-icon.search-small__close-btn-icon(icon="close-sm")
			button.search-small__submit-btn(aria-label="Найти" type="submit")
				v-svg-icon.search-small__submit-btn-icon(icon="lens")
		.search-small__filter-action
			button.search-small__filter-btn(type="button" @click.stop="openFilter")
				v-svg-icon.search-small__filter-btn-icon(icon="filter")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			icon: "/local/assets/images/car.png",
			loading: false,
			localQuery: null,
			searchTimeout: null,
			field: {
				'type': 'search',
				'label': null,
				'inputmode': 'search',
				'placeholder': 'Марка или параметры'
			},
			search: {
				remote: null,
				query: null,
				link: null,
				suggestions: []
			},
			focused: false
		};
	},

	watch: {
		localQuery() {
			this.searchInput();
		}
	},

	created() {
		//document.addEventListener('click', this.clickOutside);
		controller.events.on('search-small-open', this.open);
		//controller.events.on('search-small-close', this.close);
	},

	unmounted() {
		document.removeEventListener('click', this.clickOutside);
	},

	methods: {
		openFilter() {
			controller.openFilter();
		},

		relocate() {
			console.log('this.search.link', this.search.link)
			if (this.search.link) {
				let searchUrl = new URL(window.location.protocol + window.location.host + this.search.link);
				searchUrl.searchParams.append('query', this.localQuery);
				window.location = searchUrl;
			}
		},

		open() {
			document.body.classList.add('state--search-small-open');
		},

		close() {
			this.localQuery = null;
			this.search.suggestions = null;
			document.body.classList.remove('state--search-small-open');
		},

		clickOutside(e) {
			if (!this.$el.contains(e.target)) {
				controller.closeSearchSmall();
			}
		},

		searchInput() {
			clearTimeout(this.searchTimeout);
			if (this.localQuery) {
				//controller.openSearchSmall();
				this.searchTimeout = setTimeout(this.requestDataLoad, 200);
			} else {
				//controller.closeSearchSmall();
			}
		},

		requestDataLoad() {
			this.dataLoad({
				url: this.search.remote,
				delay: true,
				data: {
					query: this.localQuery,
					bxajaxid: this.bxajaxid
				}
			});
		},

		dataSet(data) {
			if (!this.search.remote) {
				this.search = data;
			}
			if (this.localQuery && this.localQuery === data.query) {
				this.search = data;
			}
		}
	}
};
</script>